import React from "react";
import TransactionLookupLayout from "./TransactionLookup/TransactionLookupLayout";
import TransactionLookupTabs from "./TransactionLookup/TransactionLookupTabs";

function TransactionLookupDashboard(props) {
    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-body">

                        <TransactionLookupTabs tansactionLookupData={props.tansactionLookupData}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default (TransactionLookupDashboard);

